import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  EVENT_STATUS_ENDED,
  EVENT_STATUS_NORMAL,
  EVENT_STATUS_CANCELED,
  EVENT_STATUS_UPCOMING,
  EVENT_STATUS_HAPPENING,
} from 'app/constants/messages'

import { ERROR, NORMAL, ACCENT, UNAVAILABLE } from 'app/constants/statusColors'
import StatusBadge from 'app/componentV4/Status/Badge'

const EventBadge = (props) => {
  const { status } = props
  const { formatMessage } = useIntl()

  const handleEventStatus = (status) => {
    switch (status) {
      case EVENT_STATUS_NORMAL:
        return
      case EVENT_STATUS_UPCOMING:
        return (
          <StatusBadge
            type={ACCENT}
            label={formatMessage({ id: 'text.status.upcoming' })}
          />
        )
      case EVENT_STATUS_HAPPENING:
        return (
          <StatusBadge
            type={NORMAL}
            label={formatMessage({ id: 'text.status.happening' })}
          />
        )
      case EVENT_STATUS_ENDED:
        return (
          <StatusBadge
            type={UNAVAILABLE}
            label={formatMessage({ id: 'text.status.ended' })}
          />
        )
      case EVENT_STATUS_CANCELED:
        return (
          <StatusBadge
            type={ERROR}
            label={formatMessage({ id: 'text.status.canceled' })}
          />
        )
      default:
        return
    }
  }

  return <>{handleEventStatus(status)}</>
}

EventBadge.propTypes = {
  status: PropTypes.number,
}

export default EventBadge
